require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButtonIOS = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _color = _interopRequireDefault(require("color"));

var _RadioButtonGroup = require("./RadioButtonGroup");

var _utils = require("./utils");

var _MaterialCommunityIcon = _interopRequireDefault(require("../MaterialCommunityIcon"));

var _TouchableRipple = _interopRequireDefault(require("../TouchableRipple"));

var _theming = require("../../core/theming");

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/RadioButton/RadioButtonIOS.tsx";

var RadioButtonIOS = function (_React$Component) {
  (0, _inherits2["default"])(RadioButtonIOS, _React$Component);

  function RadioButtonIOS() {
    (0, _classCallCheck2["default"])(this, RadioButtonIOS);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(RadioButtonIOS).apply(this, arguments));
  }

  (0, _createClass2["default"])(RadioButtonIOS, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          onPress = _this$props.onPress,
          theme = _this$props.theme,
          status = _this$props.status,
          value = _this$props.value,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["disabled", "onPress", "theme", "status", "value"]);
      var checkedColor = disabled ? theme.colors.disabled : this.props.color || theme.colors.accent;
      var rippleColor;

      if (disabled) {
        rippleColor = (0, _color["default"])(theme.colors.text).alpha(0.16).rgb().string();
      } else {
        rippleColor = (0, _color["default"])(checkedColor).fade(0.32).rgb().string();
      }

      return React.createElement(_RadioButtonGroup.RadioButtonContext.Consumer, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 78
        }
      }, function (context) {
        var checked = (0, _utils.isChecked)({
          contextValue: context === null || context === void 0 ? void 0 : context.value,
          status: status,
          value: value
        }) === 'checked';
        return React.createElement(_TouchableRipple["default"], (0, _extends2["default"])({}, rest, {
          borderless: true,
          rippleColor: rippleColor,
          onPress: disabled ? undefined : function () {
            (0, _utils.handlePress)({
              onPress: onPress,
              value: value,
              onValueChange: context === null || context === void 0 ? void 0 : context.onValueChange
            });
          },
          accessibilityTraits: disabled ? ['button', 'disabled'] : 'button',
          accessibilityComponentType: checked ? 'radiobutton_checked' : 'radiobutton_unchecked',
          accessibilityRole: "button",
          accessibilityStates: disabled ? ['disabled'] : [],
          accessibilityLiveRegion: "polite",
          style: styles.container,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 88
          }
        }), React.createElement(_reactNative.View, {
          style: {
            opacity: checked ? 1 : 0
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 112
          }
        }, React.createElement(_MaterialCommunityIcon["default"], {
          allowFontScaling: false,
          name: "check",
          size: 24,
          color: checkedColor,
          direction: _reactNative.I18nManager.isRTL ? 'rtl' : 'ltr',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 113
          }
        })));
      });
    }
  }]);
  return RadioButtonIOS;
}(React.Component);

exports.RadioButtonIOS = RadioButtonIOS;
(0, _defineProperty2["default"])(RadioButtonIOS, "displayName", 'RadioButton.IOS');

var styles = _reactNative.StyleSheet.create({
  container: {
    borderRadius: 18,
    padding: 6
  }
});

var _default = (0, _theming.withTheme)(RadioButtonIOS);

exports["default"] = _default;